"use strict";
/**
 * @packageDocumentation
 * @module harmony-utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAddress = exports.isBech32TestNetAddress = exports.isBech32Address = exports.isBlockNumber = exports.DefaultBlockParams = exports.isWs = exports.isHttp = exports.isHex = exports.isFunction = exports.isObject = exports.isJsonString = exports.isArray = exports.isBoolean = exports.isString = exports.isInt = exports.isNumber = exports.isHash = exports.isPublicKey = exports.isPrivateKey = exports.isAddress = exports.isKeyString = void 0;
exports.isKeyString = function (keyString, lengh) {
    return !!keyString.replace('0x', '').match("^[0-9a-fA-F]{" + lengh + "}$");
};
exports.isKeyString.validator = 'isKeyString';
exports.isAddress = function (address) {
    return exports.isKeyString(address, 40);
};
exports.isAddress.validator = 'isAddress';
exports.isPrivateKey = function (privateKey) {
    return exports.isKeyString(privateKey, 64);
};
exports.isPrivateKey.validator = 'isPrivateKey';
exports.isPublicKey = function (publicKey) {
    return exports.isKeyString(publicKey, 66);
};
exports.isPublicKey.validator = 'isPublicKey';
exports.isHash = function (hash) {
    return exports.isKeyString(hash, 64);
};
exports.isHash.validator = 'isHash';
/**
 * [isNumber verify param is a Number]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isNumber = function (obj) {
    return obj === +obj;
};
exports.isNumber.validator = 'isNumber';
/**
 * [isNumber verify param is a Number]
 * @param  {any}  obj [value]
 * @return {boolean}     [boolean]
 */
exports.isInt = function (obj) {
    return exports.isNumber(obj) && Number.isInteger(obj);
};
exports.isInt.validator = 'isInt';
/**
 * [isString verify param is a String]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isString = function (obj) {
    return obj === "" + obj;
};
exports.isString.validator = 'isString';
/**
 * [isBoolean verify param is a Boolean]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isBoolean = function (obj) {
    return obj === !!obj;
};
exports.isBoolean.validator = 'isBoolean';
/**
 * [isArray verify param input is an Array]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isArray = function (obj) {
    return Array.isArray(obj);
};
exports.isArray.validator = 'isArray';
/**
 * [isJson verify param input is a Json]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isJsonString = function (obj) {
    try {
        return !!JSON.parse(obj) && exports.isObject(JSON.parse(obj));
    }
    catch (e) {
        return false;
    }
};
exports.isJsonString.validator = 'isJsonString';
/**
 * [isObject verify param is an Object]
 * @param  {any}  obj [value]
 * @return {Boolean}     [boolean]
 */
exports.isObject = function (obj) {
    return obj !== null && !Array.isArray(obj) && typeof obj === 'object';
};
exports.isObject.validator = 'isObject';
/**
 * [isFunction verify param is a Function]
 * @param  {any}  obj [value]
 * @return {Boolean}     [description]
 */
exports.isFunction = function (obj) {
    return typeof obj === 'function';
};
exports.isFunction.validator = 'isFunction';
exports.isHex = function (obj) {
    if (!exports.isString(obj)) {
        throw new Error(obj + " is not string");
    }
    return ((obj.startsWith('0x') || obj.startsWith('-0x')) &&
        exports.isNumber(Number.parseInt(("" + obj).toLowerCase().replace('0x', ''), 16)));
};
exports.isHex.validator = 'isHex';
exports.isHttp = function (obj) {
    if (!exports.isString(obj)) {
        throw new Error(obj + " is not valid url");
    }
    else {
        return obj.startsWith('http://') || obj.startsWith('https://');
    }
};
exports.isHttp.validator = 'isHttp';
exports.isWs = function (obj) {
    if (!exports.isString(obj)) {
        throw new Error(obj + " is not valid url");
    }
    else {
        return obj.startsWith('ws://') || obj.startsWith('wss://');
    }
};
exports.isWs.validator = 'isWs';
var DefaultBlockParams;
(function (DefaultBlockParams) {
    DefaultBlockParams["earliest"] = "earliest";
    DefaultBlockParams["pending"] = "pending";
    DefaultBlockParams["latest"] = "latest";
})(DefaultBlockParams = exports.DefaultBlockParams || (exports.DefaultBlockParams = {}));
exports.isBlockNumber = function (obj) {
    var blockParams = [
        DefaultBlockParams.earliest,
        DefaultBlockParams.pending,
        DefaultBlockParams.latest,
    ];
    if (!exports.isString(obj)) {
        throw new Error(obj + " is not valid blockNumber");
    }
    return exports.isHex(obj) || blockParams.some(function (val) { return val === obj; });
};
exports.isBlockNumber.validator = 'isBlockNumber';
exports.isBech32Address = function (raw) {
    return !!raw.match(/^one1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}/);
};
exports.isBech32Address.validator = 'isBech32Address';
exports.isBech32TestNetAddress = function (raw) {
    return !!raw.match(/^tone1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}/);
};
exports.isBech32TestNetAddress.validator = 'isBech32TestNetAddress';
exports.isValidAddress = function (address) {
    if (!exports.isString(address)) {
        throw new Error(address + " is not string");
    }
    if (exports.isAddress(address) || exports.isBech32Address(address) || exports.isBech32TestNetAddress(address)) {
        return true;
    }
    else {
        return false;
    }
};
exports.isValidAddress.validator = 'isValidAddress';
//# sourceMappingURL=validators.js.map